import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sky-forgot-password',
  templateUrl: './sky-forgot-password.component.html',
  styleUrls: ['./sky-forgot-password.component.scss']
})
export class SkyForgotPasswordComponent {
  @Input() scope;
}
